module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._v("\n        Add User\n      ")]), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Login"
    },
    model: {
      value: (_vm.userLogin),
      callback: function($$v) {
        _vm.userLogin = $$v
      },
      expression: "userLogin"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "User name"
    },
    model: {
      value: (_vm.modelName),
      callback: function($$v) {
        _vm.modelName = $$v
      },
      expression: "modelName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "User email"
    },
    model: {
      value: (_vm.userEmail),
      callback: function($$v) {
        _vm.userEmail = $$v
      },
      expression: "userEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "password",
      "placeholder": "User password"
    },
    model: {
      value: (_vm.userPassword),
      callback: function($$v) {
        _vm.userPassword = $$v
      },
      expression: "userPassword"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "Age"
    },
    model: {
      value: (_vm.userAge),
      callback: function($$v) {
        _vm.userAge = $$v
      },
      expression: "userAge"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Sex",
      "items": _vm.sex
    },
    model: {
      value: (_vm.userSex),
      callback: function($$v) {
        _vm.userSex = $$v
      },
      expression: "userSex"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Description (bio)",
      "textarea": ""
    },
    model: {
      value: (_vm.userDescription),
      callback: function($$v) {
        _vm.userDescription = $$v
      },
      expression: "userDescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [(_vm.avatar) ? _c('v-img', {
    attrs: {
      "size": "50",
      "aspect-ratio": "1",
      "src": _vm.avatar
    }
  }) : _vm._e(), _vm._v(" "), (_vm.uploadPercentage !== 0 && _vm.uploadPercentage !== 100) ? _c('v-progress-linear', {
    attrs: {
      "value": _vm.uploadPercentage,
      "color": "light-blue"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-3 ml-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.disabled.uploadPhotoForEmbalmersBtn,
      "loading": _vm.disabled.uploadPhotoForEmbalmersBtn,
      "prepend-icon": _vm.uploadStatus,
      "type": "file"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.inputUpload.click()
      }
    }
  }, [_vm._v("Upload Optional Photo\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "inputUpload",
    attrs: {
      "accept": ".jpg,.png",
      "type": "file"
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "color": "success",
      "multi-line": "",
      "timeout": 2000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is bookable"
    },
    model: {
      value: (_vm.userIsVendor),
      callback: function($$v) {
        _vm.userIsVendor = $$v
      },
      expression: "userIsVendor"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.saveNewDisabled
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76f8d32b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/AddUserButton.vue
// module id = 989
// module chunks = 1